function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgForward = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.485,
    height: 8.933,
    viewBox: "0 0 11.485 8.933",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.957 18.933v-2.776a2.07 2.07 0 0 1 2.074-2.074h6.636L13.21 16.54l.67.67 3.605-3.605L13.88 10l-.67.67 2.457 2.457H9.031A3.036 3.036 0 0 0 6 16.157v2.776z",
    transform: "translate(-6 -10)",
    style: {
      fill: "#3953fb"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forward.092f5203.svg";
export { ForwardRef as ReactComponent };